import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DataService } from '../../common/data.service';
import { AppTokenHandler } from '../../common/app-token-handler';
import { AlertService } from '../../common/alert.service';
import { environment } from 'src/environments/environment';
import { AzureADAuthService } from '../../msal-code/azure-auth.service';
import { Subject, throwError } from 'rxjs';
import { takeUntil, catchError } from 'rxjs/operators';
import { ProgressService } from '../../common/progress.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
    DigiPitchID: number = 0;
    private azure_token: string = '';
    private readonly _destroying$ = new Subject<void>();
    constructor(private appToken: AppTokenHandler, private gservice: DataService, private route: Router,
        private aroute: ActivatedRoute, private alertService: AlertService, private authADService: AzureADAuthService, private progressService: ProgressService) { }
    ngOnInit() {
        //try {
        //    this.aroute.params.subscribe(params =>
        //        this.DigiPitchID = params['id']);
        //}
        //catch (error) {
        //    this.DigiPitchID = 0;
        //}
        //if (!this.DigiPitchID) {
        //    this.DigiPitchID = 0;
        //}
        this.progressService.ChangeProgressStatus(true);
        if (environment.isHostingEnvAzure) {
            this.acquireAzureToken();
        }
        else {
            this.GetUserDetails();
        }
    }
    ngOnDestroy(): void {
        this.progressService.ChangeProgressStatus(false);
        this._destroying$.next();
        this._destroying$.complete();
    }
    async acquireAzureToken() {
        this.authADService.handleQueryParameters()
            .pipe(
                takeUntil(this._destroying$),
                catchError(error => {
                    return throwError(() => error);
                })
            )
            .subscribe({
                next: (result) => {
                    if (result) {
                        this.azure_token = result;
                        this.GetUserDetails();
                    }
                }
            });
    }
    GetUserDetails() {
        if (this.azure_token) {
            this.appToken.setAzureTokenInCookie(this.azure_token);
        }
        this.gservice.Login(this.DigiPitchID, this.azure_token).subscribe((data: any) => {
            this.appToken.setSessionToken(data);
            this.progressService.ChangeProgressStatus(false);
            if (data.UserInfo.ConsentAccepted) {
                if (data.UserInfo.DigiPitchID > 0) {
                    this.route.navigate(['/home/SearchResume']);
                }
                else {
                    this.route.navigate(['/home']);
                }
            } else {
                this.route.navigate(['/Consent']);
            }
        },
            (error: Response) => {
                this.progressService.ChangeProgressStatus(false);
                if (error.status <= 0) {
                    this.route.navigate(['/badrequest']);
                }
                else if (error.status == 401) {
                    this.route.navigate(['/unauthorize']);
                }
                else {
                    this.alertService.notify('error', 'Server Error', error.statusText);
                }
            });
    }
};
